import React from 'react';
import TextFilter from 'components/list/Filters/types/TextFilter';

const NameFilter = <TextFilter
    label='filters.components.name.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='name'
/>;

export default NameFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/NameFilter.js